import $appConfig from "@/config/app.config";
import { $paths } from "@/constants";

const { snackbar } = $appConfig;

/**
 * State of the module
 */
const state = {
  snackbar: {
    value: false,
    message: "",
    hide: false,
    type: snackbar.snackbarTypes.error,
    icon: snackbar.config.error.icon,
    previousError: "",
  },
};

/**
 * Mutations constants
 */
const SET_SNACKBAR = "SET_SNACKBAR_ERROR";
const HIDE_SNACKBAR = "HIDE_SNACKBAR";

/**
 *  Mutations
 */
const mutations = {
  [SET_SNACKBAR](state, data) {
    state.snackbar = { ...state.snackbar, ...data };
  },
  /**
   * Overides api error message visualisation in snackbar globally
   */
  [HIDE_SNACKBAR](state, hide) {
    state.snackbar.hide = hide;
  },
};

/**
 *  Actions of the ui module
 */
const actions = {
  /**
   * Handles global snackbar
   */
  setSnackbar({ commit }, data) {
    commit(SET_SNACKBAR, data);
  },
};

/**
 * Module getters
 */
const getters = {
  snackbar({ snackbar }) {
    return snackbar;
  },
  /**
   * Determines if the path passed in the param is of session expired or logged out page
   * @returns {Boolean}
   */
  isSessionExpiredRoute:
    () =>
    ({ path }) => {
      const { loggedOut } = $paths;

      const isAuthExpired = [loggedOut].includes(path);
      return isAuthExpired;
    },
  /**
   * Previous error message ocurred in the application
   */
  previousError({ snackbar }) {
    return snackbar.previousError;
  },
  isSnackbarHidden({ snackbar }) {
    return snackbar.hide;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
